import { CheckCircleFilled, MoreCircle } from '@ixigo/icons';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { formatDate } from '../../utils/common';
import { InactiveChatInfoProps } from './index.types';

const InactiveChatInfo: FC<InactiveChatInfoProps> = ({ createdAt, updatedAt }) => (
    <div className='flex flex-row gap-5'>
        <div className='flex flex-col items-center justify-center'>
            <MoreCircle fontSize={18} className='text-charcoal-600' />
            <div className='w-px h-5 bg-charcoal-500' />
            <CheckCircleFilled className='text-green-600' fontSize={18} />
        </div>
        <div className='flex flex-col items-center self-center justify-center gap-[7px]'>
            <Typography variant='body-xs' className='self-start text-charcoal-600'>
                Chat opened on {formatDate(createdAt, 'E, d MMM • h:mm a')}
            </Typography>
            <Typography variant='body-xs' className='self-start text-green-600'>
                Chat closed on {formatDate(updatedAt, 'E, d MMM • h:mm a')}
            </Typography>
        </div>
    </div>
);

export default InactiveChatInfo;
